export const ACTIVE_MATCH_TICKETS_LS = 'turboLive.active.match.tickets';
export const MATCH_TICKETS = ['ticketus', 'active', 'sportEventToTickets'];
